import { apiFetch } from '../api';

/**
 * Obtiene todos los grupos disponibles (solo nombres)
 * @returns {Promise<Array>} - [{ GRUPO: "nombre" }]
 */
export async function getGroups(username = '') {
  const query = username ? `?username=${encodeURIComponent(username)}` : '';
  const res = await apiFetch(`/groups${query}`);
  if (!res.ok) throw new Error("No se pudieron obtener los grupos");
  return await res.json();
}

/**
 * Consulta los datos completos de un grupo por su nombre
 * @param {string} name - Nombre del grupo
 * @returns {Promise<Object>} - { COD_ID, COD_CLIENTE, NOMBRE, ACTIVO }
 */
export async function getGroupByName(name) {
  const encodedName = encodeURIComponent(name);
  const res = await apiFetch(`/group?name=${encodedName}`);
  if (!res.ok) throw new Error("No se pudo obtener el grupo");
  const data = await res.json();
  return Array.isArray(data) ? data[0] : data;
}

/**
 * Crea un nuevo grupo
 * @param {Object} groupData - { COD_CLIENTE, NOMBRE, ACTIVO }
 * @returns {Promise<Object>}
 */
export async function createGroup(groupData) {
  const res = await apiFetch('/group', {
    method: 'POST',
    body: JSON.stringify(groupData)
  });

  const data = await res.json();
  if (!res.ok || data.status !== 'OK') {
    throw new Error("No se pudo crear el grupo");
  }

  return data;
}

/**
 * Modifica un grupo existente
 * @param {Object} groupData - { COD_ID, COD_CLIENTE, NOMBRE, ACTIVO }
 * @returns {Promise<Object>}
 */
export async function updateGroup(groupData) {
  const res = await apiFetch('/group', {
    method: 'PUT',
    body: JSON.stringify(groupData)
  });

  const data = await res.json();
  if (!res.ok || data.status !== 'OK') {
    throw new Error("No se pudo actualizar el grupo");
  }

  return data;
}

/**
 * Elimina (lógicamente) un grupo existente
 * @param {Object} groupData - { COD_ID, COD_CLIENTE, NOMBRE }
 * @returns {Promise<Object>}
 */
export async function deleteGroup(groupData) {
  const res = await apiFetch('/group', {
    method: 'PATCH',
    body: JSON.stringify(groupData)
  });

  const data = await res.json();
  if (!res.ok || data.status !== 'OK') {
    throw new Error("No se pudo eliminar el grupo");
  }

  return data;
}


